import { PlusOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Input, Modal, Select, Table } from "antd";
import moment from "moment";
import { getColumns } from "./modules/getColumns";
import { usePromotion } from "./modules/usePromotion";

const { Option } = Select;
const { RangePicker } = DatePicker;

const PromotionManagementScreen = () => {
  const {
    editingPromotion,
    form,
    promotionType,
    promotions,
    rooms,
    ratePlans,
    loading,
    isModalVisible,
    handleCreate,
    handleEdit,
    handleDelete,
    handleModalOk,
    handleModalCancel,
    handlePromotionTypeChange,
  } = usePromotion();

  const columns = getColumns({ handleEdit, handleDelete });

  return (
    <div className="container">
      <h1>Promotion Management</h1>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={handleCreate}
        style={{ marginBottom: 16 }}
      >
        Create Promotion
      </Button>
      <Table
        dataSource={promotions}
        columns={columns}
        rowKey="_id"
        loading={loading}
        pagination={{ pageSize: 10 }}
        scroll={{ x: 1000 }}
      />

      <Modal
        title={editingPromotion ? "Edit Promotion" : "Create Promotion"}
        visible={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label="Promotion Name"
            rules={[{ required: true, message: "Please enter promotion name" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="promotionType"
            label="Promotion Type"
            rules={[
              { required: true, message: "Please select promotion type" },
            ]}
          >
            <Select onChange={handlePromotionTypeChange}>
              <Option value="Basic Deal">Basic Deal</Option>
              <Option value="Last Minute">Last Minute</Option>
              <Option value="Early Bird">Early Bird</Option>
              <Option value="Seasonal">Seasonal</Option>
              <Option value="Special Offer">Special Offer</Option>
              <Option value="Promo Code">Promo Code</Option>
              <Option value="Member">Member</Option>
            </Select>
          </Form.Item>

          {promotionType === "Promo Code" && (
            <Form.Item
              name="promoCode"
              label="Promo Code"
              rules={[
                { required: true, message: "Please enter a unique promo code" },
              ]}
            >
              <Input placeholder="Enter a unique promo code" />
            </Form.Item>
          )}

          {/* Dynamic condition fields based on promotion type */}
          {promotionType === "Last Minute" && (
            <Form.Item
              name="lastMinuteDays"
              label="Days before Check-in"
              rules={[
                {
                  required: true,
                  message: "Please specify how many days before check-in",
                },
              ]}
            >
              <Input type="number" />
            </Form.Item>
          )}

          {promotionType === "Early Bird" && (
            <Form.Item
              name="earlyBirdDays"
              label="Days in Advance"
              rules={[
                {
                  required: true,
                  message:
                    "Please specify how far in advance customers need to book",
                },
              ]}
            >
              <Input type="number" />
            </Form.Item>
          )}

          <Form.Item
            name="discountPercentage"
            label="Discount Percentage"
            rules={[
              { required: true, message: "Please enter discount percentage" },
            ]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            name="applicableBookDates"
            label="Applicable Book Dates"
            rules={[{ required: true, message: "Please select booking dates" }]}
          >
            <RangePicker
              format="DD-MM-YYYY"
              disabledDate={(current) =>
                current && current < moment().startOf("day")
              }
            />
          </Form.Item>
          <Form.Item
            name="applicableStayDates"
            label="Applicable Stay Dates"
            rules={[{ required: true, message: "Please select stay dates" }]}
          >
            <RangePicker
              format="DD-MM-YYYY"
              disabledDate={(current) =>
                current && current < moment().startOf("day")
              }
            />
          </Form.Item>
          <Form.Item
            name="applicableRooms"
            label="Applicable Rooms"
            rules={[{ required: false }]}
          >
            <Select mode="multiple" placeholder="Select applicable rooms">
              {rooms.map((room) => (
                <Option key={room._id} value={room._id}>
                  {room.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="applicableRatePlans"
            label="Applicable Rate Plans"
            rules={[{ required: false }]}
          >
            <Select mode="multiple" placeholder="Select applicable rate plans">
              {ratePlans.map((ratePlan) => (
                <Option key={ratePlan._id} value={ratePlan._id}>
                  {ratePlan.rateplanname}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default PromotionManagementScreen;
